export default __webpack_public_path__ + "static/media/offsiteAutobusIcon.10bd35c5.svg";